import React, { useEffect, useState } from "react";
import { Checkbox, Spinner } from "@ogt/ui";
import { useAtomValue, useSetAtom } from "jotai";
import {
  parkingEnabledAtom,
  parkingPoisAtom,
  parkingRequestedNameAtom,
} from "../../../../atoms";
import { fetchParkingSpots } from "../../../../api/parkingSpots";

export function ParkingSection() {
  const enabled = useAtomValue(parkingEnabledAtom);
  const setEnabled = useSetAtom(parkingEnabledAtom);
  const setParkingPois = useSetAtom(parkingPoisAtom);

  const [loading, setLoading] = useState(false);
  const setRequestedName = useSetAtom(parkingRequestedNameAtom);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const pois = await fetchParkingSpots();
        if (!cancelled) setParkingPois(pois);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled, setParkingPois]);

  return (
    <Checkbox
      withLabel
      id="parking-spots-toggle"
      checked={enabled}
      onCheckedChange={(next) => {
        const on = next === true;
        setEnabled(on);
        if (on) {
          setRequestedName(null);
        }
      }}
      disabled={loading}
      className="min-h-4"
    >
      {loading ? (
        <span className="flex items-center h-4 gap-2">
          <Spinner className="w-4 h-4" />
          Laddar...
        </span>
      ) : enabled ? (
        "Dölj parkeringsplatser"
      ) : (
        "Visa parkeringsplatser"
      )}
    </Checkbox>
  );
}
